import Parse from "parse";
import React from "react";

import styled from "styled-components";
import { ParseField } from "./ParseField";

interface Props {
  object: Parse.Object;
  fields: string[];
  isInline?: boolean;
  gap?: number;
}

const ParseFieldContainer = styled.div<{ gap?: number }>`
  display: ${(props) => (props.gap !== 0 ? "flex" : "block")};
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

export const ParseFields = React.memo<Props>(function ParseFields({
  object,
  fields,
  isInline = false,
  gap = 0,
}) {
  return (
    <ParseFieldContainer gap={gap}>
      {fields.map((field, i, a) => (
        <div key={field}>
          <ParseField object={object} field={field} isInline={isInline} />
          {gap === 0 ? i !== a.length - 1 && ", " : ""}
        </div>
      ))}
    </ParseFieldContainer>
  );
});
